module.exports = __webpack_public_path__ + "img/lottba1.ea4f502a.png";